<template>
  <div
    class="app-main-content"
    type="primary"
  >
    <div class="grid-view">
      <div class="main-content">
        <el-form :inline="true" label-width="90px" label-position="left" @submit.native.prevent>
          <el-form-item :label="$t('sysMonitor.sopSendLog.relationId')">
            <el-input v-model="search.jobNo" class="input-w" />
          </el-form-item>
          <el-form-item :label="$t('sysMonitor.sopSendLog.type')">
            <el-select v-model="search.type" clearable class="input-w">
              <el-option v-for="(item,index) in $constantI18n('sopTypes')" :key="index" :label="item.name" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('sysMonitor.sopSendLog.pushingChannel')">
            <el-select v-model="search.pushingChannel" clearable class="input-w">
              <el-option v-for="(item,index) in $constantI18n('pushingChannel')" :key="index" :label="item.name" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('sysMonitor.sopSendLog.receivingUser')">
            <el-input v-model="search.receivingUser" class="input-w" />
          </el-form-item>
          <el-form-item :label="$t('sysMonitor.sopSendLog.receivingTxt')">
            <el-input v-model="search.receivingTxt" class="input-w" />
          </el-form-item>
          <el-form-item :label="$t('sysMonitor.sopSendLog.pushingResult')">
            <el-select v-model="search.pushingResult" clearable class="input-w">
              <el-option v-for="(item,index) in $constantI18n('pushResult')" :key="index" :label="item.name" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('sysMonitor.sopSendLog.pushNode')">
            <el-dropdown class="input-w" trigger="click" placement="bottom-start" @visible-change="onChangePushNode">
              <span class="el-dropdown-link">
                <el-input v-model="search.pushNodeTxt" class="input-w" :readonly="true" />
              </span>
              <el-dropdown-menu slot="dropdown" class="app-main-inner-row row-grid input-w" style="width: 350px;height: 200px;">

                <cargo-ag-grid
                  :show-side-bar="false"
                  :grid-options="pushNodeTree.gridOptions"
                  :column-defs="pushNodeTree.columnDefs"
                  :row-data="pushNodeTree.rowData"
                  style="width:100%;height:100%;"
                />
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
          <el-form-item :label="$t('sysMonitor.sopSendLog.dateCreated')">
            <el-date-picker
              v-model="search.pushTimeStar"
              style="width:173px "
              value-format="yyyy-MM-dd"
              :placeholder="$t('SystemMonitor.StartDate')"
            />
            <span style="color:#dfe4ed;padding:0 4px">—</span>
            <el-date-picker
              v-model="search.pushTimeEnd"
              style="width:173px "
              value-format="yyyy-MM-dd"
              :placeholder="$t('SystemMonitor.EndDate')"
            />
          </el-form-item>
          <el-form-item style="display: block">
            <el-button size="mini" type="primary" @click="fetchList">{{ $t('common.btn.query') }}</el-button>
          </el-form-item>
        </el-form>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="250001"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            v-show="search.total>0"
            config-module="250001"
            :total="search.total"
            :page.sync="search.pageNum"
            :limit.sync="search.pageSize"
            @pagination="fetchList"
          />
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import { getSopEmailLog, getPushNodeTree } from '@/api/sopEmailRecord'
import { getGridSelected } from '@/utils/agGrid'
import { cacheName, cache } from '@/utils/cacheManager'
import { getLoading } from '@/utils/utilBaseElement'
import { SopUtil } from '@/class/cargo/model/utils/SopUtil'

export default {
  name: 'SopEmailRecord',
  components: { },
  data() {
    return {
      search: {
        total: 0, // total传递到后端无用
        pageNum: 1,
        pageSize: 10,
        pushTime: [],
        jobNo: '',
        pushTimeStar: '',
        pushTimeEnd: '',
        type: null,
        pushingChannel: null,
        receivingUser: '',
        receivingTxt: '',
        pushingResult: null,
        pushNodeTxt: '',
        pushNode: ''
      },
      pushNodeTree: {
        gridOptions: {},
        gridApi: {},
        columnDefs: null,
        rowData: []
      },
      nodeLabelMap: {}, // 推送节点Map
      fullscreenLoading: null,
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: null,
      rowData: [],
      alertTypes: []
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  watch: {
    'search.pushTime'(val) { // todo 待删除
      this.search.pushTimeStar = val ? val[0] : ''
      this.search.pushTimeEnd = val ? val[1] : ''
    }
  },
  async beforeCreate() {
    const sopConfig = await SopUtil.getInstance()
    const warnRules = sopConfig.warnDateEnum
    this.alertTypes = warnRules.filter(item => item.warnType === 2)
  },
  created() {
    const self = this
    this.columnDefs = [
      {
        headerName: this.$t('sysMonitor.sopSendLog.orderNo'),
        field: 'orderNo',
        width: 200
      },
      {
        headerName: this.$t('Invoice.invoice_invoiceNo'),
        field: 'invoiceNo',
        width: 200
      },
      {
        headerName: this.$t('sysMonitor.sopSendLog.relationId'),
        field: 'relationId',
        width: 200
      },
      {
        headerName: this.$t('sysMonitor.sopSendLog.dateCreated'),
        field: 'dateCreated',
        width: 200
      },
      {
        headerName: this.$t('sysMonitor.sopSendLog.type'),
        field: 'type',
        width: 200,
        cellRenderer: (params) => {
          if (params.value !== undefined) {
            const type = self.$constantI18n('sopTypes').find(item => {
              return item.value === params.value
            })
            return type.name || params.value
          }
          return ''
        }
      },
      {
        headerName: this.$t('sysMonitor.sopSendLog.pushNode'),
        field: 'pushNode',
        width: 200,
        cellRenderer: (params) => {
          if (params.value === 'AMS') {
            return this.$t('SeaExport.AmsReceiptRemind')
          }
          if (params.data.type === 4 && this.alertTypes && this.alertTypes.length > 0) { // 数据服务
            const remind = this.alertTypes.find(item => item.code + '' === params.value)
            return this.isZh ? remind.chineseName : remind.englishName
          }
          return this.nodeLabelMap ? this.nodeLabelMap[params.value] : ''
        }
      },
      {
        headerName: this.$t('sysMonitor.sopSendLog.pushingChannel'),
        field: 'pushingChannel',
        width: 100,
        cellRenderer: (params) => {
          if (params.value !== undefined) {
            const type = self.$constantI18n('pushingChannel').find(item => {
              return item.value === params.value
            })
            return type.name || params.value
          }
          return ''
        }
      },
      {
        headerName: this.$t('sysMonitor.sopSendLog.pushingResult'),
        field: 'pushingResult',
        width: 100,
        cellRenderer: (params) => {
          if (params.value !== undefined) {
            const type = self.$constantI18n('pushResult').find(item => {
              return item.value === params.value
            })
            return type.name || params.value
          }
          return ''
        }

      },
      {
        headerName: this.$t('sysMonitor.sopSendLog.receivingUser'),
        field: 'receivingUser',
        width: 200
      },
      {
        headerName: this.$t('SystemMonitor.ContentDescription'), field: `receivingTxt`, width: 180,
        cellRendererFramework: 'CargoGridShowBigContent'
      },
      {
        headerName: this.$t('sysMonitor.sopSendLog.modifyDate'),
        field: 'modifyDate',
        width: 200,
        cellRenderer: (params) => {
          // 发票不需要展示时间
          if (params.data.type !== 6) {
            return params.value
          }
          return ''
        }
      }, {
        headerName: this.$t('sysMonitor.sopSendLog.file'), field: `uuid`, width: 180,
        cellRendererFramework: 'sopEmailOptBtn'
      }]

    this.gridOptions = {
      rowSelection: 'multiple',
      suppressRowClickSelection: false,
      context: {
        componentParent: this
      }
    }

    this.pushNodeTree.columnDefs = []

    this.pushNodeTree.gridOptions = {
      rowSelection: 'multiple',
      groupDefaultExpanded: 0,
      suppressRowClickSelection: false,
      treeData: true,
      getDataPath: (data) => {
        return data.path.split(',')
      },
      autoGroupColumnDef: {
        headerName: this.$t('SystemMonitor.Name'),
        width: 320,
        valueFormatter: (params) => {
          if (params.data.code) {
            // return `[${params.data.code}]` + params.data.chineseName
            return params.data.chineseName
          } else {
            return params.data.chineseName
          }
        },
        cellRendererParams: {
          suppressCount: true,
          suppressDoubleClickExpand: true,
          checkbox: (params) => {
            return params.data.type === 3
          }
        }
      }
    }
  },
  async mounted() {
    this.fullscreenLoading = getLoading()
    await Promise.all([this.fetchNodeTree()]).finally(() => {
      this.fullscreenLoading.close()
    })
  },
  methods: {
    fetchNodeTree() {
      getPushNodeTree().then(res => {
        const result = res.data
        this.pushNodeTree.rowData = result.treeList
        this.nodeLabelMap = result.nodeLabelMap
      })
    },
    async fetchList() {
      this.fullscreenLoading = getLoading()
      await cache.load(cacheName.CONFIG)
      const storageConfigURL = cache.config.get('StorageURL')
      getSopEmailLog({ ...this.search }).then(res => {
        this.search.pageNum = res.data.pageNum
        this.search.pageSize = res.data.pageSize
        this.search.total = Number(res.data.total)
        this.rowData = res.data.list.map(item => {
          console.log('storageConfigURL', storageConfigURL)
          console.log('item.eamilUrlPrefix', item.emailUrlPrefix)
          item.emailUrlPrefix = storageConfigURL || item.emailUrlPrefix
          return item
        })
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    onChangePushNode(isShow) {
      if (!isShow) {
        const rows = getGridSelected(this.pushNodeTree.gridOptions)
        const nodeMap = new Map()
        const pushNode = []
        const pushNodeTxt = []
        rows.forEach(row => {
          pushNode.push(row.uuid)
          pushNodeTxt.push(row.chineseName)
          nodeMap.set(row.code, row.chineseName)
        })

        this.search.pushNode = pushNode.join(',')
        this.search.pushNodeTxt = pushNodeTxt.join(',')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ip-config{
  .input-w{
    width: 350px!important;
  }
}
</style>
